module.exports = __webpack_public_path__ + "assets/img/Bottom_column.47bf03fc.png";